import { CursorCssFeature } from './cursor.types'
import { cursor } from './cursorCompNode'
import { cursorDomApplier } from './cursorDomApplier'
import { cursorVariants } from './cursorVariantsCompNode'

export const cursorCssFeature: CursorCssFeature = {
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { cursor, cursorVariants },
	intermediateNodes: {},
	dataMaps: ['cursor'],
	domApplier: cursorDomApplier,
}
